import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import FilterComponent from "./FilterComponent";
import UnileverLogo from "./../Assests/Unilever logo.svg";
import helpInfo from "./../Assests/help-info.svg";
import Logo1 from "./../Assests/logo-1.svg";
import { Grid } from "@mui/material";
import UserIcon from "./../Assests/Ellipse 3.svg";
import CGOFilterComponent from "./CGOFilterComponent";
import { useSelector } from "react-redux";
// import { SxProps } from "@mui/materialem/styleFunctionSx";

const settings = ["Profile", "Account", "Dashboard", "Logout"];

function Navbar() {
  const selectedUsecase = localStorage.getItem("selectedUsecase");
  const selectCGOInput = localStorage.getItem("selectCGOInput");

  let sr = localStorage.getItem("selectedRadio");
  let selectedCategory;
  if (selectedUsecase === "Short Term" || selectedUsecase === "Medium Term") {
    if (sr === "masterData") {
      selectedCategory = "Integrated Processing and Packaging Facility";
    } else {
      selectedCategory = "Separate Processing and Packaging Facilities";
    }
  }

  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null,
  );

  const userData = useSelector(
    (state: any) => state.InputDataReducers.apiUserData,
  );

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <>
      <AppBar component="div" position="sticky" className="navbar">
        <div className="top-header">
          <div className="brand-logo">
            <div>
              <a href={`${window.location.origin}`}>
                <img
                  src={UnileverLogo}
                  alt="Unilever logo"
                  title="Click here to go back Landing page"
                />
              </a>
            </div>
            <div>
              <img src={Logo1} alt="logo" width="100px" />
            </div>
          </div>
          <div className="selected-usecase">
            {/* <IconButton onClick={handleOpenUserMenu}>
              <Avatar style={{}} />
            </IconButton>{" "} */}
            {selectedUsecase}
          </div>
          <div className="pull-left selected-category">{selectedCategory}</div>
          <div className="headerUser pull-right">
            <div className="help-info">
              <a href="#">
                <img src={helpInfo} alt="Help" title="Help" />
              </a>
            </div>
            <Box
              onClick={handleOpenUserMenu}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <h3>{userData ? userData.userName : "User"}</h3>
                <h3>
                  {userData?.userType} - {userData?.groupName}
                </h3>
              </div>
              <KeyboardArrowDown
                sx={{
                  ml: 0.5,
                  transform: anchorElUser ? "rotate(180deg)" : "none",
                }}
              />
            </Box>
            <Box sx={{ flexGrow: 0 }}>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem key={setting} onClick={handleCloseUserMenu}>
                    <Typography>{setting}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </div>
        </div>
      </AppBar>
      <div>
        {selectCGOInput === "CGOInput" ? (
          <CGOFilterComponent />
        ) : (
          <FilterComponent />
        )}
      </div>
    </>
  );
}
export default Navbar;
